import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Page } from '../../../models/paging/page';
import { PagedData } from '../../../models/paging/paged-data';
import { saveAs as importedSaveAs } from 'file-saver';
import { ManufacturerService } from '../../../services/manufacturer.service';
import { Manufacturer } from '../../../models/manufacturer';

@Component({
  selector: 'app-manufacturers',
  templateUrl: './manufacturers.component.html',
  styleUrls: ['./manufacturers.component.css']
})
export class ManufacturersComponent implements OnInit {
  filter: any = {
    name: ''
  };
  init: boolean;
  page = new Page();
  rows = Array<Manufacturer>();

  columns = [
    { name: 'Name', prop: 'name' },
    { name: 'Option', prop: '' },
  ];

  constructor(public manufacturerService: ManufacturerService, public router: Router) {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
    this.init = true;
  }

  edit(row) {
    this.router.navigate(['administration/manufacturers/manage'], { queryParams: { id: row.id } });
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.manufacturerService.getResults(this.page, this.filter.name).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }
  generateExcel() {
    this.manufacturerService.getExcel(this.page, this.filter.name).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
